import { render, staticRenderFns } from "./IngresoDespacho.vue?vue&type=template&id=50e0c8db&scoped=true&"
import script from "./IngresoDespacho.vue?vue&type=script&lang=js&"
export * from "./IngresoDespacho.vue?vue&type=script&lang=js&"
import style0 from "./IngresoDespacho.vue?vue&type=style&index=0&id=50e0c8db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e0c8db",
  null
  
)

export default component.exports